var map = {
	"./AMD Logo.svg": 5271,
	"./Amazon Logo.svg": 1301,
	"./Amazon Music Logo.svg": 8010,
	"./Amazon Web Services Logo.svg": 3415,
	"./Apple Logo Black.svg": 2216,
	"./Applied Materials Inc Logo.svg": 8266,
	"./Atlassian Logo.svg": 8957,
	"./Boeing Full Logo.svg": 6702,
	"./Capgemini 201x Logo.svg": 8259,
	"./Capital One Logo.svg": 5237,
	"./Deloitte Logo.svg": 9313,
	"./INRIX Logo.svg": 2339,
	"./Intel Logo 2023.svg": 7520,
	"./JNJ Logo.svg": 5243,
	"./Lockheed Martin Logo 2011-2022.svg": 3118,
	"./Microsoft Logo 2012.svg": 6528,
	"./Morgan Stanley Logo.svg": 1647,
	"./Murata Manufacturing Logo.svg": 7751,
	"./NVIDIA Logo.svg": 310,
	"./Palo Alto Networks 2020 Logo.svg": 7666,
	"./Twitter Logo.svg": 4730,
	"./United States Army Logo.svg": 7613,
	"./Ver Di.svg": 8396,
	"./Vmware Logo.svg": 6385,
	"./Workday Logo.svg": 3476,
	"./intuitive-surgical-seeklogo.png": 1416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9007;